import React, { FC } from "react";
import {
  Extras,
  JobPost,
  JobPostOriginType,
  Location,
  Remote,
} from ".prisma/client";
import { OrganisationBlock } from "./OrganisationBlock";
import { RemoteRegion } from "data/remoteRegions/remoteRegions";
import { JobPostRemoteType, Organisation } from "@prisma/client";
import { AssignedTag, NewTag, TagType } from "types/tags";
import { EmploymentTypesBlock } from "./EmploymentTypesBlock";
import { TagsBlock } from "./TagsBlock";
import { OnsiteLocationsBlock } from "./OnsiteLocationsBlock";
import { RemoteLocationsBlock } from "./RemoteLocationsBlock";

interface Props {
  jobPost: JobPost & {
    hiringOrganisation?: Organisation;
    sourcingOrganisation?: Organisation;
    locations: Location[];
    remote: Remote & { regionsPopulated: RemoteRegion[] };
    extras: Extras;
    tags?: (AssignedTag & NewTag)[];
  };
}

export const SummaryBlock: FC<Props> = ({ jobPost }) => (
  <div className="space-y-6">
    {(jobPost.originType === JobPostOriginType.SCRAPED ||
      jobPost.originType === JobPostOriginType.SCRAPED_CHROME_EXTENSION ||
      (jobPost.originType === JobPostOriginType.POSTED &&
        jobPost.hasHiringOrganisation)) && (
      <div>
        <h2 className="font-bold">Company</h2>
        <OrganisationBlock organisation={jobPost.hiringOrganisation} />
      </div>
    )}
    {jobPost.hasSourcingOrganisation && (
      <div>
        <h2 className="font-bold">Recruitment company</h2>
        <OrganisationBlock organisation={jobPost.sourcingOrganisation} />
      </div>
    )}
    {jobPost.locations.length > 0 && (
      <div>
        <h2 className="font-bold">Onsite Locations</h2>
        <OnsiteLocationsBlock locations={jobPost.locations} />
      </div>
    )}
    {
      //jobPost.remote?.type === JobPostRemoteType.GENERAL ||
      (jobPost.remote?.type === JobPostRemoteType.WORLDWIDE ||
        jobPost.remote?.type === JobPostRemoteType.SELECTED_REGIONS) && (
        <div>
          <h2 className="font-bold">Hires remotely in</h2>
          <RemoteLocationsBlock remote={jobPost.remote} />
        </div>
      )
    }
    {jobPost.tags?.filter((t) => t.type === TagType.EMPLOYMENT_TYPE)?.length >
      0 && (
      <div>
        <h2 className="font-bold">Employment type</h2>
        <EmploymentTypesBlock tags={jobPost.tags} tagCN="block" />
      </div>
    )}
    {jobPost.extras?.providesVisaSponsorship && (
      <div>
        <h2 className="font-bold">Visa Sponsorship</h2>
        <div>
          {jobPost.extras?.providesVisaSponsorship ? (
            <a
              href={`/search?tags=visa-sponsorship`}
              className="hover:underline"
              rel="nofollow"
            >
              Available
            </a>
          ) : (
            "Not available"
          )}
        </div>
      </div>
    )}
    {jobPost.extras?.providesPaidRelocation && (
      <div>
        <h2 className="font-bold">Paid relocation</h2>
        <div>
          {jobPost.extras?.providesPaidRelocation ? (
            <a
              href={`/search?tags=paid-relocation`}
              className="hover:underline"
              rel="nofollow"
            >
              Available
            </a>
          ) : (
            "Not available"
          )}
        </div>
      </div>
    )}
    {jobPost.tags?.length > 0 && (
      <div>
        <h2 className="font-bold">Tags</h2>
        <TagsBlock
          tags={jobPost.tags}
          cN=""
          tagCN="inline-block mr-1 mb-0.5 px-1.5 py-1 text-xxs font-semibold bg-gray-100 rounded-sm"
        />
      </div>
    )}
  </div>
);
